import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-mac-cell',
    templateUrl: './device-status-mac-cell.component.html'
})
export class DeviceStatusMacCellComponent extends TableCellComponent implements OnInit {
    @Input() public item: IDeviceStatusListSummary;

    public macCellFormGroup: FormGroup;
    public macAddressFormControl: FormControl;

    public ngOnInit() {
        this.macCellFormGroup = new FormGroup({});
        this.macAddressFormControl = new FormControl(this.item.moduleId);
        this.macCellFormGroup.addControl('macAddresses', this.macAddressFormControl);
    }

    public macChangeHandler($event: MatSelectChange) {
        this.item.moduleId = $event.value;

        // tslint:disable:triple-equals
        const selectedMac = this.item.macAddresses.filter(mac => (mac as any).id == this.item.moduleId);
        if (selectedMac.length == 1) {
            this.item.macAddress = selectedMac[0].mac;
        }
    }
}
